// extracted by mini-css-extract-plugin
export var option = "_77-0";
export var optionCard = "_77-f";
export var optionContent = "_77-g";
export var optionIcon = "_77-i";
export var optionIconBox = "_77-h";
export var optionLabel = "_77-j";
export var optionPill = "_77-m";
export var optionPillBadge = "_77-p";
export var optionPillIcon = "_77-n";
export var optionPillLabel = "_77-o";
export var optionRadio = "_77-k";
export var optionRadioInner = "_77-l";
export var optionReveal = "_77-2";
export var optionRevealDelay0 = "_77-3";
export var optionRevealDelay1 = "_77-4";
export var optionRevealDelay10 = "_77-d";
export var optionRevealDelay11 = "_77-e";
export var optionRevealDelay2 = "_77-5";
export var optionRevealDelay3 = "_77-6";
export var optionRevealDelay4 = "_77-7";
export var optionRevealDelay5 = "_77-8";
export var optionRevealDelay6 = "_77-9";
export var optionRevealDelay7 = "_77-a";
export var optionRevealDelay8 = "_77-b";
export var optionRevealDelay9 = "_77-c";
export var optionSelected = "_77-1";